import { createContext } from "react";

/** The map owns web presentation so the reward survives map loading and sheet remounts. */
export const LearnSummaryMapWelcomePresentationContext = createContext<{
  isRewardPopover: boolean;
  offerDailyReward: (day: string) => void;
} | null>(null);
